import React from 'react';

export const partial = (fn, ...args) => fn.bind(null, ...args);

const _pipe = (f, g) => (...args) => g(f(...args))

export const pipe = (...fns) => fns.reduce(_pipe)

export const hoc =(WrapperComponent, wrapperProps) => Component =>
    props =>
        <WrapperComponent {...{...wrapperProps, ...props}}>
            <Component {...props}/>
        </WrapperComponent>

export const adjustDate = (hour, minute)=>{
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date;
};


export const adjustTime = (date, time)=>{
    const d = new Date(date.getTime());
    d.setHours(time.getHours());
    d.setMinutes(time.getMinutes());
    return d;
};


// WEBPACK FOOTER //
// ./src/lib/utils.js